import type { ISocial } from "../../../../types/models/social.models.types";
import type { IUser } from "../../../../types/models/user.models.types";

import { usePostHttp } from "../../http.hook";

interface IBody {
  social: string;
}

export enum FixedPayoutStatus {
  active = "active",
  inactive = "inactive",
}

export interface IProposalSocials {
  proposalSocial: {
    id: string;
    addedByUser: IUser;
    fixedPayout: { amount: number; status: FixedPayoutStatus } | null;
    fixedPayoutAmount: { amount: number; status: FixedPayoutStatus } | null;
    commentCount: number;
    commentReadByUsersList: [string];
    createdAt: Date;
    updatedAt: Date;
  } | null;
  social: ISocial;
}

interface IResponse {
  campaignProposalSocial: IProposalSocials;
}

export function useAddProposalSocialAdminHttp() {
  return usePostHttp<IBody, IResponse>({
    path: "/admin/campaigns/proposals/:proposalId/socials",
  });
}
